import { render } from "./sendAccessProblem.vue?vue&type=template&id=17ab8813"
import script from "./sendAccessProblem.vue?vue&type=script&lang=js"
export * from "./sendAccessProblem.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__